<template>
  <div class="shortlist-section">
    <headerCustom></headerCustom>
    <div class="template main-content sidenav-part ng-scope">
      <div>
        <div class="heading-sec">
          <div class="row">
            <div class="col-md-4 column">
              <div class="heading-profile">
                <h3>Shortlisted Hotels</h3>
              </div>
            </div>
          </div>
        </div>
        <!-- Top Bar Chart -->
        <div class="panel-content">
          <div class="row">
            <div class="col-md-12">
              <div class="widget">
                <div class="table-area">
                  <div class="widget-title">
                    <div class="float-right">
                      <form class="search-form mr-form">
                        <input
                          type="text "
                          class="form-control"
                          v-model="searchText"
                          @input="viewShortlistHotels(1)"
                          placeholder="Search Here..."
                        />
                      </form>
                    </div>
                    <div class="d-flex">
                      <div>
                        <h3>
                          List of Shortlisted Hotels
                          <span class="tableTotal">(Total : {{ totalCount }})</span>
                        </h3>
                      </div>
                      <div class=" ml-3 ">
                        <b-button variant="success" @click="generateExcelForShortlist(page)"
                          >Download</b-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table text-nowrap">
                      <thead>
                        <tr>
                          <th>Sr.No.</th>

                          <th>Hotel Name</th>

                          <th>Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in hotelList" v-bind:key="item._id">
                          <td>{{ index + 1 + (page - 1) * 10 }}</td>
                          <td>
                            <div>{{ item._id.name }}</div>
                          </td>
                          <td>
                            <div>{{ item.count }}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="table-body-contents text-center m-3 font-size-md
                    font-weight-bold text-muted"
                    v-if="hotelList.length === 0"
                  >
                    No Data Found
                  </div>
                  <div class="text-center" v-if="hotelList.length >= 1">
                    <b-pagination
                      class="mb-0 float-right"
                      v-model="page"
                      align="center"
                      :total-rows="totalCount"
                      :per-page="formData.limit"
                      @input="viewShortlistHotels(page)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerCustom from "@/components/Header.vue";
import apiservice from "@/service/apiservice";
import moment from "moment";

export default {
  components: {
    headerCustom
  },
  data() {
    return {
      searchText: "",
      hotelList: [],
      page: 1,
      formData: { limit: 10 },
      totalCount: 0,
      perPage: 10,
      errors: [],
      moment: moment,
      selected: null
    };
  },
  created() {
    this.viewShortlistHotels(this.page);
  },
  methods: {
    viewShortlistHotels(pageNo) {
      this.hotelList = [];
      this.formData.page = pageNo;
      this.formData.limit = this.perPage;
      this.formData.search = this.searchText;

      apiservice.viewShortlistHotels(this.formData, data => {
        if (data.status === 200) {
          this.hotelList = data.data.result;
          this.totalCount = data.data.count;
        } else {
        }
      });
    },
    generateExcelForShortlist() {
      apiservice.generateExcelForShortlist(this.formData, data => {
        apiservice.downloadExcel(data, "ShortList_List");
      });
    }
  }
};
</script>

<style lang="scss">
.shortlist-section {
  .text {
    color: black;
  }
}
</style>
